import React from 'react';

import { Box, Heading, Icon, Text } from '@zillow/constellation-10';
import { IconMegaphoneFilled } from '@zillow/constellation-icons';

import { StyledContainer, StyledIconAwardRibbon } from './StyledComponents';

type Props = {
  icon?: React.ReactNode;
  children?: React.ReactNode;
  backgroundColor?: string;
  header?: string | null;
  isPremiumTip?: boolean;
};

const WizardTipCard = ({
  icon = <IconMegaphoneFilled />,
  children = null,
  backgroundColor = 'backgroundWhite',
  header = null,
  isPremiumTip = false,
}: Props) => (
  <StyledContainer className="WizardTipCard" backgroundColor={backgroundColor} isPremiumTip={isPremiumTip}>
    <Box css={{ marginBottom: '400' }}>
      {isPremiumTip ? (
        <>
          <StyledIconAwardRibbon fontColor="brand" size="xs" />
          <Text textStyle="body-sm-bold" css={{ color: 'blue.400' }} asChild>
            <span> Premium</span>
          </Text>
        </>
      ) : (
        <Icon render={icon} size="xl" css={{ color: 'icon.express.trust.hero' }} />
      )}
    </Box>

    {header && (
      <Box css={{ marginBottom: '400' }}>
        <Heading level={6} id="tip-title">
          {header}
        </Heading>
      </Box>
    )}

    {children}
  </StyledContainer>
);

export default WizardTipCard;
